import { render, staticRenderFns } from "./SiteIncidentList.vue?vue&type=template&id=c4e61754&scoped=true&"
import script from "./SiteIncidentList.vue?vue&type=script&lang=js&"
export * from "./SiteIncidentList.vue?vue&type=script&lang=js&"
import style0 from "./SiteIncidentList.vue?vue&type=style&index=0&id=c4e61754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e61754",
  null
  
)

export default component.exports